import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumToChinese'
})
export class EnumToChinesePipe implements PipeTransform {

    transform(value: any, enumType:any): string {
        const key = Object.keys(enumType).find( k =>k === value);
        return key ? enumType[key] : '';
    }

}
